"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var ClientStartup = _interopRequireWildcard(require("./clientStartup"));
var _handleError2 = _interopRequireDefault(require("./handleError"));
var _ComponentRegistry = _interopRequireDefault(require("./ComponentRegistry"));
var _StoreRegistry = _interopRequireDefault(require("./StoreRegistry"));
var _serverRenderReactComponent2 = _interopRequireDefault(require("./serverRenderReactComponent"));
var _buildConsoleReplay2 = _interopRequireDefault(require("./buildConsoleReplay"));
var _createReactElement = _interopRequireDefault(require("./createReactElement"));
var _Authenticity = _interopRequireDefault(require("./Authenticity"));
var _context = _interopRequireDefault(require("./context"));
var ctx = (0, _context["default"])();
var DEFAULT_OPTIONS = {
  traceTurbolinks: false
};
ctx.ReactOnRails = {
  /**
   * Main entry point to using the react-on-rails npm package. This is how Rails will be able to
   * find you components for rendering.
   * @param components (key is component name, value is component)
   */
  register: function register(components) {
    _ComponentRegistry["default"].register(components);
  },
  /**
   * Allows registration of store generators to be used by multiple react components on one Rails
   * view. store generators are functions that take one arg, props, and return a store. Note that
   * the setStore API is different in that it's the actual store hydrated with props.
   * @param stores (keys are store names, values are the store generators)
   */
  registerStore: function registerStore(stores) {
    if (!stores) {
      throw new Error('Called ReactOnRails.registerStores with a null or undefined, rather than ' + 'an Object with keys being the store names and the values are the store generators.');
    }
    _StoreRegistry["default"].register(stores);
  },
  /**
   * Allows retrieval of the store by name. This store will be hydrated by any Rails form props.
   * Pass optional param throwIfMissing = false if you want to use this call to get back null if the
   * store with name is not registered.
   * @param name
   * @param throwIfMissing Defaults to true. Set to false to have this call return undefined if
   *        there is no store with the given name.
   * @returns Redux Store, possibly hydrated
   */
  getStore: function getStore(name) {
    var throwIfMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return _StoreRegistry["default"].getStore(name, throwIfMissing);
  },
  /**
   * Set options for ReactOnRails, typically before you call ReactOnRails.register
   * Available Options:
   * `traceTurbolinks: true|false Gives you debugging messages on Turbolinks events
   */
  setOptions: function setOptions(newOptions) {
    if ('traceTurbolinks' in newOptions) {
      this.options.traceTurbolinks = newOptions.traceTurbolinks; // eslint-disable-next-line no-param-reassign

      delete newOptions.traceTurbolinks;
    }
    if ((0, _keys["default"])(newOptions).length > 0) {
      throw new Error('Invalid options passed to ReactOnRails.options: ', (0, _stringify["default"])(newOptions));
    }
  },
  /**
   * Allow directly calling the page loaded script in case the default events that trigger react
   * rendering are not sufficient, such as when loading JavaScript asynchronously with TurboLinks:
   * More details can be found here:
   * https://github.com/shakacode/react_on_rails/blob/master/docs/additional-reading/turbolinks.md
   */
  reactOnRailsPageLoaded: function reactOnRailsPageLoaded() {
    ClientStartup.reactOnRailsPageLoaded();
  },
  /**
   * Returns CSRF authenticity token inserted by Rails csrf_meta_tags
   * @returns String or null
   */
  authenticityToken: function authenticityToken() {
    return _Authenticity["default"].authenticityToken();
  },
  /**
   * Returns header with csrf authenticity token and XMLHttpRequest
   * @param {*} other headers
   * @returns {*} header
   */
  authenticityHeaders: function authenticityHeaders() {
    var otherHeaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _Authenticity["default"].authenticityHeaders(otherHeaders);
  },
  // /////////////////////////////////////////////////////////////////////////////
  // INTERNALLY USED APIs
  // /////////////////////////////////////////////////////////////////////////////

  /**
   * Retrieve an option by key.
   * @param key
   * @returns option value
   */
  option: function option(key) {
    return this.options[key];
  },
  /**
   * Allows retrieval of the store generator by name. This is used internally by ReactOnRails after
   * a rails form loads to prepare stores.
   * @param name
   * @returns Redux Store generator function
   */
  getStoreGenerator: function getStoreGenerator(name) {
    return _StoreRegistry["default"].getStoreGenerator(name);
  },
  /**
   * Allows saving the store populated by Rails form props. Used internally by ReactOnRails.
   * @param name
   * @returns Redux Store, possibly hydrated
   */
  setStore: function setStore(name, store) {
    return _StoreRegistry["default"].setStore(name, store);
  },
  /**
   * Clears hydratedStores to avoid accidental usage of wrong store hydrated in previous/parallel
   * request.
   */
  clearHydratedStores: function clearHydratedStores() {
    _StoreRegistry["default"].clearHydratedStores();
  },
  /**
   * ReactOnRails.render("HelloWorldApp", {name: "Stranger"}, 'app');
   *
   * Does this:
   *   ReactDOM.render(React.createElement(HelloWorldApp, {name: "Stranger"}),
   *     document.getElementById('app'))
   *
   * @param name Name of your registered component
   * @param props Props to pass to your component
   * @param domNodeId
   * @param hydrate Pass truthy to update server rendered html. Default is falsy
   * @returns {virtualDomElement} Reference to your component's backing instance
   */
  render: function render(name, props, domNodeId, hydrate) {
    var componentObj = _ComponentRegistry["default"].get(name);
    var reactElement = (0, _createReactElement["default"])({
      componentObj: componentObj,
      props: props,
      domNodeId: domNodeId
    });
    var render = hydrate ? _reactDom["default"].hydrate : _reactDom["default"].render; // eslint-disable-next-line react/no-render-return-value

    return render(reactElement, document.getElementById(domNodeId));
  },
  /**
   * Get the component that you registered
   * @param name
   * @returns {name, component, generatorFunction, isRenderer}
   */
  getComponent: function getComponent(name) {
    return _ComponentRegistry["default"].get(name);
  },
  /**
   * Used by server rendering by Rails
   * @param options
   */
  serverRenderReactComponent: function serverRenderReactComponent(options) {
    return (0, _serverRenderReactComponent2["default"])(options);
  },
  /**
   * Used by Rails to catch errors in rendering
   * @param options
   */
  handleError: function handleError(options) {
    return (0, _handleError2["default"])(options);
  },
  /**
   * Used by Rails server rendering to replay console messages.
   */
  buildConsoleReplay: function buildConsoleReplay() {
    return (0, _buildConsoleReplay2["default"])();
  },
  /**
   * Get an Object containing all registered components. Useful for debugging.
   * @returns {*}
   */
  registeredComponents: function registeredComponents() {
    return _ComponentRegistry["default"].components();
  },
  /**
   * Get an Object containing all registered store generators. Useful for debugging.
   * @returns {*}
   */
  storeGenerators: function storeGenerators() {
    return _StoreRegistry["default"].storeGenerators();
  },
  /**
   * Get an Object containing all hydrated stores. Useful for debugging.
   * @returns {*}
   */
  stores: function stores() {
    return _StoreRegistry["default"].stores();
  },
  resetOptions: function resetOptions() {
    this.options = (0, _assign["default"])({}, DEFAULT_OPTIONS);
  }
};
ctx.ReactOnRails.resetOptions();
ClientStartup.clientStartup(ctx);
var _default = ctx.ReactOnRails;
exports["default"] = _default;